export enum MetadataFieldType {
  STRING = "STRING",
  NUMBER = "NUMBER",
  // STRING_ARRAY = "STRING_ARRAY",
  // BOOLEAN = "BOOLEAN",
  GPS = "GPS",
}
export interface MetadataDetector {
  id: number;
  createdAt: string;
  updatedAt: string;
  enabled: boolean;
  isDefault: boolean;
  slug: string;
  prompt: string;
  label: string;
  type: MetadataFieldType;
  reportTemplateId?: number;
}

export interface MetadataDetectorPayload {
  isDefault?: boolean;
  slug: string;
  prompt: string;
  type: MetadataFieldType;
  label: string;
}

export const typeLabel: Record<MetadataFieldType, string> = {
  [MetadataFieldType.NUMBER]: "Nombre",
  [MetadataFieldType.STRING]: "Texte",
  // [MetadataFieldType.BOOLEAN]: "Booléen",
  // [MetadataFieldType.STRING_ARRAY]: "Tableau de texte",
  [MetadataFieldType.GPS]: "Coordonnée (##.######, ##.######)",
};

export const metadataDetectorTypes = Object.values(MetadataFieldType);
